/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
// TODO fix
import { docData } from 'rxfire/firestore';
import { db } from '../Firebase';
import { doc } from 'firebase/firestore';
import { tap, shareReplay, Observable } from 'rxjs';
import { LobbyStateT } from '../shared/codecs/LobbyState';
import { decodable } from '../rxjs/Decode';
export function LobbyState(org_uid) {
    const lobby_state_doc = doc(db, 'organizations', org_uid, 'lobby', 'state');
    return docData(lobby_state_doc).pipe(decodable(LobbyStateT), tap(lobby => console.log(`Lobby status: ${lobby.status}`)), shareReplay(1));
}
